import moment from 'moment'
import { fetchDataInitTable } from '../shared-script/fetchDataInitTable'
import defaultSortParams from '../shared-script/defaultSortParams'
const { moco } = require('../../MbaasClient')

export async function isProducts(params, resource) {
  const { page, perPage } = params.pagination
  const { dateGte, dateLte } = params.filter || {}
  const { name, country, denomination, category, product_code } = params.filter
  let { field: sortField, order: sortOrder } = params.sort

  // adjust sorting params, default sort DESC
  const [field, order] = defaultSortParams(sortField, sortOrder)
  let filterObject = moco.composeFilter()
  let includedTables = []

  switch (true) {
    case Boolean(params.filter.q):
      // search by product di halaman pricing
      filterObject = filterObject.contains((x) => x.toLower('name'), params.filter.q.toLowerCase())
      break
    case Boolean(name):
      filterObject = filterObject.contains((x) => x.toLower('name'), name.toLowerCase())
      break
    case Boolean(country):
      filterObject = filterObject.eq('country', country)
      break
    case Boolean(denomination):
      filterObject = filterObject.eq('denomination', denomination)
      break
    case Boolean(category):
      filterObject = filterObject.contains((x) => x.toUpper('category'), category.toUpperCase())
      break
    case Boolean(product_code):
      filterObject = filterObject.contains(
        (x) => x.toUpper('product_code'),
        product_code.toUpperCase()
      )
      break
    default:
      console.log('default')
      break
  }

  if (dateGte && dateLte) {
    filterObject = filterObject.and((x) =>
      x
        .ge('created_at', moment(dateGte).startOf('day').toISOString())
        .le('created_at', moment(dateLte).endOf('day').toISOString())
    )
  }

  if (filterObject !== '') filterObject = filterObject.toString()

  const [data, total] = await fetchDataInitTable(
    includedTables,
    resource,
    filterObject,
    order,
    field,
    page,
    perPage
  )

  return { data: data, total: total }
}
